import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputStaticLabelContext = /*#__PURE__*/createContext(undefined);
export const InputStaticLabelProvider = ({
  truncateStringStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(InputStaticLabelContext.Provider, {
    value: {
      truncateStringStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `InputStaticLabel` component.
 * Note: The context is only available when the `InputStaticLabel` component is rendered as an ancestor.
 * @returns InputStaticLabelContext - The context for the `InputStaticLabel` component.
 * @returns InputStaticLabelContext.truncateStringStyleOverrides - CSS overrides to apply to the `TruncateString` component.
 */
export const useInputStaticLabelContext = () => {
  const inputStaticLabelContext = useContext(InputStaticLabelContext);
  return inputStaticLabelContext;
};